import { useWeb3 } from './useWeb3';

export const getAddress = async (): Promise<string> => {
  const web3 = useWeb3();

  return await web3.signer.getAddress();
};
